export default "__VITE_ASSET__BzkMr5kB__"